import e from"styled-components";const i=e.div`
	position: relative;
	border-radius: ${({borderRadius:e})=>`${e}px`};
	padding: 28px 14px;
	overflow: hidden;
	height: 100%;
	box-sizing: border-box;

	&::before {
		content: '';
		position: absolute;
		inset: 0;
		background: url(${({imageUrl:e})=>e});
		background-position: center;
		background-size: cover;
		filter: blur(30px) brightness(0.8);
		z-index: 2;
	}
`,t=e.div`
	background-color: black;
	position: absolute;
	inset: 0;
	opacity: ${({opacity:e})=>e};
	z-index: 2;
`,o=e.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	gap: 28px;
	z-index: 3;
	position: relative;
	height: 100%;
`,r=e.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 28px;
	word-break: break-word;
`,n=e.h1`
	margin: 0;
	color: #ffffff;
	font-weight: 500;
	text-align: center;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,d=e.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
`,a=e.img`
	object-fit: cover;
	border-radius: 9999px;
	object-position: ${({position:e})=>e?`${e.x}% ${e.y}%`:"center"};
`,c=e.span`
	padding: 5px 10px;
	font-size: 12px;
	color: ${({color:e})=>e};
	background: ${({background:e})=>e};
	border-radius: 9999px;
	width: fit-content;
	box-sizing: border-box;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,s=e.span`
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
	color: #ffffff;
`,p=e.div`
	opacity: 0.5;
	height: 20px;
`;export{p as CardArrowContainer,i as CardContainer,o as CardContent,r as CardContentContainer,d as CardFooter,n as CardHeading,a as CardImage,c as CardLabel,s as CardLinkText,t as CardOverlay};
